import { func } from "../../../utils";

// Landing page sebelum hari-H Press Conference: key visual satu layar penuh,
// melapis background teal. KV mengikuti desain Figma terbaru — desktop pakai
// poster portrait (node 10399:13652), mobile pakai banner landscape
// (node 8463:878). BG (rsvp-kv-bg) dipakai bareng halaman /rsvp, jadi tidak
// diubah; yang diganti hanya KV khusus halaman ini.
const PreEventLanding = () => {
  const alt =
    "Piala by.U 2026 Press Conference — Jakarta, Hallf Patiunus, 3 September 2026";
  return (
    <div className="fixed inset-0 overflow-hidden bg-[#0c2a3d]">
      {/* BG teal gradient, menutup seluruh layar */}
      <img
        src={func.getStaticImg("bg/rsvp-kv-bg.webp")}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* KV desktop: poster portrait transparan, pas setinggi layar */}
      <img
        src={func.getStaticImg("bg/presscon-kv-d.webp")}
        alt={alt}
        className="hidden md:block absolute inset-0 w-full h-full object-contain scale-90"
      />
      {/* KV mobile: banner landscape, center di layar */}
      <img
        src={func.getStaticImg("bg/presscon-kv-d.webp")}
        alt={alt}
        className="md:hidden absolute inset-0 w-full h-full object-contain"
      />
      {/* by.U logo: 88x56 di x108/y17 pada frame 1440 (7.5vw dari kiri) */}
      <div className="absolute left-6 top-5 h-[41px] w-[64px] lg:left-[7.5vw] lg:top-[17px] lg:h-[56px] lg:w-[88px] z-10">
        <img
          src={func.getStaticImg("illustration/byU-logo.svg")}
          alt="by.U"
          className="absolute inset-[5.36%_4.55%] max-w-none"
        />
      </div>
    </div>
  );
};

export default PreEventLanding;
